// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__15xl8","choiceBoxes":"toolbarselects_choiceBoxes__3R5qr","simpleField":"toolbarselects_simpleField__VZB9D"};